// extracted by mini-css-extract-plugin
module.exports = {"cp-modal-course__preview":"styles_cp-modal-course__preview__1SFhK","cp-modal-course__cert__preview":"styles_cp-modal-course__cert__preview__3aYF9","editor":"styles_editor__14SAA"};